import React, {PropTypes} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import QCapTable from './QCapTable';

import Checkbox from 'material-ui/Checkbox';
import axios from 'axios';

class QCapHome extends React.Component {

    constructor() {

      super();
      this.state ={myRating: [],manager: false,myTeamRating: []}
    }

    componentDidMount()
    {
      let empId = this.props.employee.empno;
      axios.get(process.env.REQ_URL + "/qcap/getRatingsForEmpId?q="+JSON.stringify(empId), {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
        let myRating = new Array();
        myRating.push(response.data.data);
        this.setState({myRating: myRating})

      }).catch((error) => {

      });
      axios.get(process.env.REQ_URL + "/qcap/getRatingsForMyTeam?q="+JSON.stringify(empId), {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
        this.setState({myTeamRating: response.data.data})

      }).catch((error) => {

      });


    }
    render() {
      console.log(this.state.myTeamRating);
        return (<div>
            <h2>My Rating</h2>
            <QCapTable data={this.state.myRating}/>

            <h2>My Team Rating</h2>
          {this.state.myTeamRating.length>0?<QCapTable data={this.state.myTeamRating}/>:null}

        </div>
        );
    }
}

QCapHome.propTypes = {};

export default QCapHome;





/** WEBPACK FOOTER **
 ** ./src/feature/qcap/QCapHome.js
 **/